export default __webpack_public_path__ + "static/media/chat_bot_image5.c667c9ca.jpg";